import { useGetAgroOverviewMapQuery } from 'services/api/Meteorology/Agro/Overview';
import { AgroOverviewVariable } from 'types/Meteorology/Agro/Overview/Dashboard';
import useOverviewErrorState from './useOverviewErrorState';

export default function useOverviewMap(variavel: AgroOverviewVariable) {
  const {
    data, error, isFetching, refetch,
  } = useGetAgroOverviewMapQuery(variavel);
  const errorKind = useOverviewErrorState(error, isFetching);

  return {
    mapData: data, isFetching, errorKind, retry: refetch,
  };
}
